export const RAK_SAVE_CLOSE_CONFIRM_MESSAGE =
  "Are you sure you want to save the changes and exit the application?";
